// TurnstileLoader.js
'use strict';
import { connect } from 'react-redux';

import { CLOUDFLARE_TURNSTILE_SITE_KEY } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import TurnstileLoader from '../component/TurnstileLoader.jsx';

const mapStateToProps = state => {
  return {
    turnstileSiteKey: getRemoteConfigData(state, CLOUDFLARE_TURNSTILE_SITE_KEY),
  };
};

export default connect(mapStateToProps, null)(TurnstileLoader);
